import { Box, Flex, HStack, Stack, Text } from "@chakra-ui/react";
import { t } from "i18next";
import {
  HlaAttributeName,
  hlaAttributeOptions,
} from "../../../../map/models/HlaAttribute";
import { coloringSteps } from "../../../../map/models/HlaColoring";
import { mapGradient, mapGradientStep } from "../../../../map/utils/map-utils";
import { HlaColoringLegendItem } from "./HlaColoringLegendItem";

interface Props {
  attributeName: HlaAttributeName;
}

export const HlaColoringAttribute: React.FC<Props> = ({ attributeName }) => {
  const options = hlaAttributeOptions[attributeName];

  if (options) {
    const nOptions = options.length;

    return (
      <>
        {options.map((option, i) => (
          <HlaColoringLegendItem key={option.value} color={mapGradientStep(nOptions, i)}>
            {t(option.translation)}
          </HlaColoringLegendItem>
        ))}
      </>
    );
  }

  const steps = coloringSteps[attributeName];

  if (steps?.length) {
    const nSteps = steps.length;

    return (
      <HStack alignItems="stretch" fontSize="xs" my={1}>
        <Flex flexShrink={0} w="6px" flexDir="column" borderRadius="3px" overflow="hidden">
          {steps.map((_, i) => (
            <Box
              key={i}
              flex={1}
              bgColor={`#${mapGradient.hsvAt(i / nSteps).toHex()}`}
            />
          ))}
        </Flex>

        <Stack gap={4}>
          <Text>{steps[0]}</Text>
          <Text>{`>= ${steps[nSteps - 1]}`}</Text>
        </Stack>
      </HStack>
    );
  }

  return null;
};